import {
  CardActionButton,
  CardTable,
  CardTableActions,
} from "features/common/components/CardTable";
import { useClientsTable } from "./useClientsTable";
import { SearchBar } from "features/common/components/SearchBar";
import { FormControlLabel, FormGroup, Switch, Typography } from "@mui/material";
import { Input } from "features/common/components/Input";
import BackButton from "features/common/components/BackButton";
import { ExportClientsModal } from "../ExportClientsModal";

export const ClientsTable = () => {
  const {
    table,
    handleSearchClientsChange,
    handleReset,
    handleBack,
    taskNr,
    handleTaskNr,
    displayMessage,
    setDisplayMessage,
    handleToggle,
    isOpenModal,
    relevantList,
    handleCloseModal,
    handleOpenModal,
    isSwitchDisabled,
    exportIsPermitted,
    isToggleOn,
  } = useClientsTable();

  return (
    <>
      <ExportClientsModal
        isOpen={isOpenModal}
        onClose={handleCloseModal}
        idList={relevantList}
        taskNr={taskNr}
      />
      <CardTable
        sticky
        tableProps={{ ...table, readonly: true }}
        title="Clients"
        actionsPanel={
          <CardTableActions>
            <SearchBar
              displayMessage={displayMessage}
              setDisplayMessage={setDisplayMessage}
              setSearchQuery={handleSearchClientsChange}
            />
            <CardActionButton
              variant="outlined"
              color="secondary"
              disabled={false}
              onClick={handleReset}
              children="RESET"
            />
            <FormGroup>
              <FormControlLabel
                sx={{ ml: "5px" }}
                control={
                  <Switch
                    onChange={handleToggle}
                    checked={isToggleOn}
                    data-testid="selected-switch"
                  />
                }
                disabled={isSwitchDisabled}
                label={
                  <Typography children="Show only selected" color="secondary" />
                }
                color="secondary"
              />
            </FormGroup>
            <Input
              size="small"
              label="Task Nr"
              value={taskNr}
              onChange={handleTaskNr}
              disabled={!exportIsPermitted}
            />
            <CardActionButton
              variant="outlined"
              color="primary"
              onClick={handleOpenModal}
              children="EXPORT"
              disabled={!exportIsPermitted}
            />
            <BackButton onClick={handleBack} />
          </CardTableActions>
        }
      />
    </>
  );
};
